/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import iconProcess from './IconProcess_Loop_03_Lottie.json';

const IconProcess = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(iconProcess))} {...props}/>
    );
}

export default IconProcess;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/iconProcess.jsx